import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';
import { RadioGroupComponent } from './radio-group.component';
import { StackModule } from '../stack/stack.module';
import { TextModule } from '../text/text.module';
import { MessageModule } from '../message/message.module';

@NgModule({
  declarations: [RadioGroupComponent],
  imports: [CommonModule, IconModule, StackModule, TextModule, MessageModule],
  exports: [RadioGroupComponent],
})
export class RadioGroupModule {}
